import React from 'react';

import { closeCurrentPopup } from '@paragon/popup-state';
import { UserSettingsDialog } from '@paragon/user-settings';

import { RootState } from '../../store';
import { getEnabledColorByOptions } from '../../store/selectors/getEnabledColorByOptionsSelector';
import { applyUserSettings } from '../../store/slices/userSettingsSlice';
import { useAppDispatch, useAppSelector } from '../hooks';

/**
 * The `UserSettingsDialog` all wired up for use in the design client.
 */
export function ConnectedUserSettingsDialog() {
  const dispatch = useAppDispatch();

  const userSettings = useAppSelector((state: RootState) => state.userSettings!);
  const colorByOptions = useAppSelector(getEnabledColorByOptions);

  return (
    <UserSettingsDialog
      settings={userSettings}
      onChange={(settings) => {
        dispatch(applyUserSettings(settings));
      }}
      enabledColorByOptions={colorByOptions}
      requestClose={() => {
        dispatch(closeCurrentPopup());
      }}
    />
  );
}
